import React from "react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.svg";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer__top">
          <Link className="footer__brand" to="/">
            <img src={logo} width="40" height="40" alt="" />
            <span>IT-Patrol</span>
          </Link>
          <div className="footer__cols">
            <div>
              <h5>Navigate</h5>
              <Link to="/services">Services</Link>
              <Link to="/apps">Apps</Link>
              <Link to="/about">About</Link>
              <Link to="/faq">FAQ</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div>
              <h5>Practices</h5>
              <Link to="/services#ecommerce">Ecommerce</Link>
              <Link to="/services#saas">SaaS</Link>
              <Link to="/services#ai">AI</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {year} IT-Patrol. Development and consulting.</span>
          <span>it-patrol.tech</span>
        </div>
      </div>
    </footer>
  );
}
